/* eslint-disable @typescript-eslint/no-explicit-any */
import { TextField, Checkbox, FormControlLabel, Autocomplete } from "@mui/material"
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers'
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers'
import dayjs from "dayjs"
import { UploadImage } from "./UploadImage"
import { OtherSelect } from "./OtherSelect"
import { MasterSelect } from "./MasterSelect"

type Props = {
  type: string,
  name: string,
  value: any,
  onChange: any,
  options?: any,
  text?: string
  disabled?: boolean,
  style?: object,
  label?: string,
  rows?: number,
}

interface WeekDays {
  Su: string
  Mo: string
  Tu: string
  We: string
  Th: string
  Fr: string
  Sa: string
}
const weekDays = { Su: '日', Mo: '月', Tu: '火', We: '水', Th: '木', Fr: '金', Sa: '土' } as WeekDays

const FormElement = (props: Props) => {
  const { type, name, value, options, onChange, text, disabled, style, label, rows } = props
  switch (type) {
    case 'text':
      return (
        <TextField
          id={name}
          name={name}
          onChange={(e: any) => {
            onChange({ name: e.target.name, value: e.target.value })
          }}
          defaultValue=""
          value={value || ""}
          disabled={disabled}
          style={style}
          label={label}
        />
      )
    case 'multitext':
      return (
        <TextField
          id={name}
          name={name}
          onChange={(e: any) => {
            onChange({ name: e.target.name, value: e.target.value })
          }}
          multiline
          defaultValue=""
          value={value || ""}
          disabled={disabled}
          style={style}
          label={label}
          rows={rows}
        />
      )
    case 'number':
      return (
        <TextField
          type="number"
          id={name}
          name={name}
          defaultValue={null}
          onChange={(e: any) => {
            onChange({ name: e.target.name, value: e.target.value })
          }}
          value={value || null}
          disabled={disabled}
          inputProps={{
            inputMode: "numeric", pattern: "[0-9]*"
          }}
          style={style}
          label={label}
        />
      )
    case 'select':
      return (
        <Autocomplete
          id={name}
          blurOnSelect={true}
          value={value || null}
          options={options && options.map((o: any) => o.label)}
          sx={{ width: 200 }}
          renderInput={(params) => <TextField {...params} name={name} label={text} />}
          onChange={
            (e: React.SyntheticEvent, value: string) => {
              onChange({ name: e.currentTarget.id.split('-')[0], value: value })
            }
          }
          disabled={disabled}
          style={style}
        />
      )
    case 'checkbox':
      return (
        <FormControlLabel
          label={text}
          control={
            <Checkbox name={name}
              onChange={(e: any) => onChange({ name: e.target.name, value: e.target.checked.toString() })}
              disabled={disabled}
              checked={value === 'true'}
              style={style}
            />
          }
        />
      )
    case 'date':
      return (
        <DatePicker
          name={name}
          label={text}
          value={dayjs(value) || dayjs(new Date())}
          onChange={(e: any) => {
            onChange({ name, value: e.format('YYYY/MM/DD')})
          }}
          format="YYYY/MM/DD"
        />
      )
    case 'datetime':
      return (
        <DateTimePicker
          name={name}
          value={value && dayjs(value)}
          format="YYYY/MM/DD HH:mm"
          viewRenderers={{
            hours: renderTimeViewClock,
            minutes: renderTimeViewClock,
            seconds: renderTimeViewClock,
          }}
          label="日時を入力してください"
          ampm={false}
          dayOfWeekFormatter={(weekDay: any) => {
            const key: keyof WeekDays = weekDay
            return weekDays[key]
          }}
          onChange={(e: any) => {
            onChange({ name, value: e.format('YYYY/MM/DD HH:mm')})
          }}
          disabled={disabled}
        />
      )
    case 'upload':
      return (
        <UploadImage
          name={name}
          value={value}
          onChange={onChange}
        >
          ファイルを選択
        </UploadImage>
      )
    case 'other':
      return (
        <OtherSelect
          name={name}
          value={value}
          options={options}
          onChange={onChange}
          disabled={disabled}
        />
      )
    case 'master':
      return (
        <MasterSelect
          name={name}
          value={value}
          optionProps={{ masterName: "hunters", labelKey: "name", valueKey: "name" }}
          label={label}
          onChange={onChange}
          disabled={disabled}
        />
      )
    default:
      return <div/>
  }
}
export default FormElement
